import { ResponseStatus as ProtoResponseStatus } from "@opstel/gen/knop/ui/v1/api/util/response_status_pb";
import { ElementOf } from "@shared/common/types/typeHelpers";
import { z } from "zod/v3";

export const RESPONSE_STATUS = ["UNKNOWN", "SUCCESS", "FAILED"] as const;
export type ResponseStatus = ElementOf<typeof RESPONSE_STATUS>;

export const responseStatusSchema = z
  .nativeEnum(ProtoResponseStatus)
  .transform((v) => RESPONSE_STATUS[v])
  .refine((val) => val !== "UNKNOWN", {
    message: "Response status may not be UNKNOWN",
  });
